import React from 'react';
import {IconButton, Tooltip} from '@mui/material';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';

function PaymentReminderIconButton({hasOverdueInvoices, onClick}) {
    if (!hasOverdueInvoices) {
        return null;
    }

    const openPaymentReminderWithoutOpeningTheRow = (event) => {
        event.stopPropagation();
        onClick();
    };

    return (
        <Tooltip title="Recordatorio de pago">
            <IconButton aria-label="Recordatorio de pago" onClick={openPaymentReminderWithoutOpeningTheRow}>
                <ForwardToInboxOutlinedIcon/>
            </IconButton>
        </Tooltip>
    );
}

export default PaymentReminderIconButton;
